var map = {
	"./department_contract_management.png": "1064",
	"./department_loan_management.png": "6975",
	"./departmental_account_management.png": "75f3",
	"./history_customer.png": "dbb1",
	"./loan_customer.png": "b8ff",
	"./my_customer.png": "c1ad",
	"./onsite_customer.png": "e914",
	"./public_pool.png": "816a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "716c";